import { Controller } from 'stimulus';

class CheckboxToggle extends Controller {
  static toggleTarget(state, target) {
    target.style.display = state ? 'block' : 'none';
  }

  connect() {
    this.checkToggle();

    if (this.element.type === 'radio') {
      this.hookupRadioEvents();
    }
  }

  disconnect() {
    if (this.element.type === 'radio') {
      this.hookupRadioEvents('removeEventListener');
    }
  }

  hookupRadioEvents(type = 'addEventListener') {
    this.getRadioButtons().forEach((radioElement) => {
      radioElement[type]('change', this.onSameInputNameChange.bind(this));
    });
  }

  onChange() {
    this.checkToggle();
  }

  onSameInputNameChange() {
    this.checkToggle();
  }

  checkToggle() {
    CheckboxToggle.toggleTarget(this.element.checked, this.getTarget());
  }

  getTarget() {
    return document.querySelector(this.data.get('target'));
  }

  getRadioButtons() {
    const radios = document.querySelectorAll(`[name="${this.element.name}"]`);
    return Array.prototype.slice.call(radios);
  }
}

CheckboxToggle.targets = [
  //
];

export default CheckboxToggle;
